import { useMutation } from '@tanstack/react-query';

import {
  Question,
  addBulkQuestions,
} from '../../../api/question/addBulkQuestions';

interface UseBulkCreateQuestionsParams {
  url: ({ quizId }: { quizId: string }) => string;
}

export function useBulkCreateQuestions({ url }: UseBulkCreateQuestionsParams) {
  return useMutation({
    mutationFn: ({
      questions,
      insertionOrder,
      quizId,
    }: {
      quizId: string;
      questions: Array<Question>;
      insertionOrder: number;
    }) =>
      addBulkQuestions({
        questions,
        bulkAddQuestionUrl: url,
        quizId,
        insertionOrder,
      }),
  });
}
